<template>
  <div class="page" v-wechat-title="'提现中心'">

    <div class="box account-tab">
      <div @click="stateCurr=1" class="flex" :class="stateCurr==1?'curr':''">
        <span>提现榜单</span>
      </div>
      <div @click="stateCurr=2" class="flex" :class="stateCurr==2?'curr':''">
        <span>收入明细</span>
      </div>
      <div @click="stateCurr=3" class="flex" :class="stateCurr==3?'curr':''">
        <span>提现记录</span>
      </div>
    </div>

    <!-- 提现榜单 -->
    <div class="account-list" :class="stateCurr == 1 ? '' : 'none'">

      <div class="account-list-rank" v-for="(item,index) in root1" :key="index">
        <div class="fl list-rank-number">
          <img src="../../assets/icon_rank00.png" alt="" v-if="index==0">
          <img src="../../assets/icon_rank01.png" alt="" v-if="index==1">
          <img src="../../assets/icon_rank02.png" alt="" v-if="index==2">
          <span v-if="index!=0&&index!=1&&index!=2"> {{index+1}}</span>
        </div>
        <div class="fl list-rank-toux">
          <img v-lazy="item.headimg" alt="">
        </div>
        <div class="fl list-rank-name">{{item.name | initName}}</div>
        <div class="fr list-rank-money">￥{{item.usemoney}}</div>
      </div>
      <p class="load-tip" ref="loadtip">{{loadText2}}</p>
    </div>

    <!-- 收入明细 -->
    <div class="account-list account-list-sr" :class="stateCurr == 2 ? '' : 'none'">
      <div class="account-search box">
        <div class="account-search-info">
          <span class="date hide">{{date2}}</span>
          <span class="num hide">收入 ￥{{number2}}</span>
        </div>
        <div class="search-con">
          <img class="icon_search" src="../../assets/icon_search.png" alt="">
          <input class="border-box" placeholder-class="phcolorColor" placeholder="解说主题" />
        </div>
        <datePickerDemo psMsg="" @transfer="getDate"></datePickerDemo>
      </div>
      <div class="account-list-data box border-box" v-for="(item,index) in root2" :key="index">
        <div class="block head-img-box">
          <img  src="../../assets/pay-member.png" v-if="item.vipid">
          <img  v-lazy="item.buyheadimg" v-else>
          <span class="hide">{{item.buyname | initName}}</span>
        </div>
        <div class="flex account-list-info border-box">
          <span class="block title hide" v-if="item.vipid">{{item.title}}</span>
          <span class="block title hide" v-else>{{item.name}}</span>

          <span class="block type hide" v-if="item.vipid">[购买会员]</span>
          <span class="block type hide" v-else>[{{item.paytype == 0?'购买解说':'打赏解说'}}]</span>

          <span class="block date hide">{{item.paytime}}</span>
        </div>
        <div class="account-list-num">
          <span class="block price hide">+{{item.money}}元</span>
        </div>
        <div class="data-border"></div>
      </div>
      <p class="load-tip" ref="loadtip">{{loadText2}}</p>
    </div>

    <!-- 提现记录 -->
    <div class="account-list account-list-tx border-box" :class="stateCurr == 3 ? '' : 'none'">
      <div class="account-search box">
        <div class="account-search-info">
          <span class="date hide">{{date3}}</span>
          <span class="num hide">提现 ￥{{number3 || 0}}</span>
        </div>
        <datePickerDemo psMsg="" @transfer="getDate1"></datePickerDemo>
      </div>
      <div class="account-list-data clearfix border-box" v-for="(item,index) in root3" :key="index" style="height: auto;padding: .18rem .24rem;">
        <div class="icon-dh-box wp20 fl">
          <img class="icon-dh" :src="item.state == 1?require('../../assets/icon_dh.png'):require('../../assets/mask_btn_close.png')" alt="">
        </div>
        <div class="fl wp60">
          <div class="block font28 cor6 lineH30 hide fontBold">{{item.state == 1?"提现成功":"提现失败"}}</div>
          <div class="block font28 cor3 lineH30 hide fontBold mt20" v-if="item.ispiao==0 && item.dprice">实际到账：<span style="color:#fc784a;">{{item.dprice}}</span></div>
          <div class="block font24 hide mt20" style="color:#bbc4c8">{{item.rtime}}</div>
        </div>
        <div class="fl wp20 num hide tr lineH30" style="color:#fc784a;">{{item.price}}元</div>
        <div class="data-border"></div>
      </div>
      <p class="load-tip" ref="loadtip">{{loadText3}}</p>
    </div>
  </div>



</template>

<script>
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'

  import {getQRcode,getUrl} from "@/service/getData";
  import {getTop,getMyincome, getMyrecord} from '@/utils/wechat'

  import AlertPoster from '../../components/AlertPoster'
  import datePicker from 'multifunctional-datepicker'
  Vue.prototype.$datepicker = datePicker
  import datePickerDemo from '../../components/datePickerDemo'
  import Vue from 'vue'
  export default {
    data(){
      return{
        TimeStamp: new Date().getTime(),  //获取当前时间
        userInfo: {}, //用户信息

        stateCurr:0,
        textAnimate:1,
        date2:'',//收入明细日期
        date3:'',//提现记录日期
        sdate2: '', //开始日期
        edate2: '', //结束日期
        sdate3: '', //开始日期
        edate3: '', //结束日期
        page2: 1,
        page3: 1,
        rows: 10,
        name: '', //解说主题

        root1: [], //榜单
        root2: [],
        root3: [],
        number2: 0,
        number3: 0,
        loadText2: "数据加载中",
        loadText3: "数据加载中",
      }
    },
    computed: {

    },
    created() {
      this.userInfo = getStore("userInfo");
      this.stateCurr = this.$route.query.stateCurr;
      this.$loading.show('数据加载中');

      let user = getStore("user",1) || "";
      if(user && user.user != '' && user.user != null && user.user != undefined){
        this.id = user.user;
      }else {
        this.$router.replace({
          path: `/extend-index`
        });
      }
      this.initPage();
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {

      //判断显示那种列表
      initPage(){
        this.date2 = this.initDate(new Date());
        this.date3 = this.initDate(new Date());

        this.getTopList()
        this.getIncomeList(this.page2)
        this.getRecordList(this.page3)
        document.documentElement.scrollTop = document.body.scrollTop = 0;
      },

      //获取top榜单列表
      getTopList(){
        var self = this;
        getTop(self.id,function(res){
          self.$loading.hide();
          if (res.errcode == "00000") {
            self.root1 = res.data
          }else {
            self.$toast(res.errmsg);
          }
        });
      },

      //获取我的收入明细列表
      getIncomeList(page2){
        var self = this;
        if(self.date2 != ''){
          self.sdate2 = self.date2 + '-01';
          self.edate2 = self.date2 + '-31';
        }

        var obj = {
          id: self.id,
          sdate: self.sdate2,
          edate: self.edate2,
          page: page2,
          rows:self.rows,
          name:self.name,
        };
        getMyincome(obj,function(res){
          self.$loading.hide();
//          console.log(res)
          var total = res.total
          var root2 = res.root
          self.number2 = res.number
          if (page2 >= Math.ceil(total / self.rows)) {
            self.loadText2 = '已经到底了'
          } else {
            self.loadText2 = '加载更多'
          }
          if (root2 && root2.length > 0) {
            self.root2 = [...self.root2, ...root2];
          } else {
            if (page2 == 1) {
              self.root2 = [];
              self.loadText2 = '暂无数据'
            } else {
              self.loadText2 = '已经到底了'
            }
          }

        });
      },

      //获取我的提现记录
      getRecordList(page3){
        var self = this;
        if(self.date3 != ''){
          self.sdate3 = self.date3 + '-01';
          self.edate3 = self.date3 + '-31';
        }

        var obj = {
          id: self.id,
          sdate: self.sdate3,
          edate: self.edate3,
          page: page3,
          rows:self.rows,
        };
        getMyrecord(obj,function(res){
          self.$loading.hide();
//          console.log(res)
          var total = res.total
          var root3 = res.root
          self.number3 = res.number
          if (page3 >= Math.ceil(total / self.rows)) {
            self.loadText3 = '已经到底了'
          } else {
            self.loadText3 = '加载更多'
          }
          if (root3 && root3.length > 0) {
            self.root3 = [...self.root3, ...root3];
          } else {
            if (page3 == 1) {
              self.root3 = [];
              self.loadText3 = '暂无数据'
            } else {
              self.loadText3 = '已经到底了'
            }
          }


        });
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          if(self.stateCurr == 2){
            loadMore(self,function(page2){
              self.getIncomeList(page2);
            });
          }else if(self.stateCurr == 3){
            loadMore(self,function(page3){
              self.getRecordList(page3);
            });
          }
        })

      },

      getDate(msg){
        this.date2= msg
        this.sdate2 = this.date2 + '-01';
        this.edate2 = this.date2 + '-31';
//        console.log(this.sdate2,this.edate2);
        this.page2 = 1
        this.root2 = []
        this.getIncomeList(this.page2);
      },

      getDate1(msg){
        this.date3= msg
        this.sdate3 = this.date3 + '-01';
        this.edate3 = this.date3 + '-31';
//        console.log(this.sdate3,this.edate3);
        this.page3 = 1
        this.root3 = []
        this.getRecordList(this.page3);
      },

      initDate(date) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        return [year, month].map(this.formatNumber).join('-');
      },
      formatNumber(n){
        n = n.toString()
        return n[1] ? n : '0' + n
      },

    },
    components: {
      datePickerDemo
    },
    filters: {
      initName: function (name) {
        if (name != "") {
          name = name.substring(0, 1) + "**"
        } else if (num > 1000) {
          name = "**"
        }
        return name;
      }

    }


  }

</script>

<style scoped>
  .wp20{width: 20%;}
  .wp60{width: 60%;}
  .page{ background:  #fff; min-height: 100vh; }
  .account-tab{width:90%;padding:0 5%;height:.92rem;line-height:.92rem;border-bottom:.01rem solid #e8e8e8; }
  .account-tab .flex{position:relative;width:30%;height:.92rem;line-height:.92rem;color:#999;}
  .account-tab .flex.curr:after{content:'';position:absolute;left:.35rem;right:.35rem;bottom:-.01rem;height:.08rem;color:#faaf39;background:#faaf39;border-radius:.05rem;}
  .account-tab .flex span{position:absolute;top:0;left:0;width:100%;height:100%;text-align:center;font-size:.28rem;z-index:2;}
  .account-tab .flex.curr span{color:#faaf39;}

  /*提现榜单*/
  .account-list-rank{ padding: .18rem 0; height: .82rem; line-height: .82rem; border-bottom: .02rem solid #faf9fb; }
  .list-rank-number{ margin-left: .24rem; width: .42rem; height: .82rem; font-size: .28rem; color: #4a4a4a; text-align: center; }
  .list-rank-number img{ width: .42rem; height: .53rem; vertical-align: middle; }
  .list-rank-toux{ margin-left: .27rem; width: .82rem; height: .82rem; border-radius: 50%; overflow: hidden; }
  .list-rank-toux img{ width: .82rem; height: .82rem; border-radius: 50%;object-fit: cover; }
  .list-rank-name{ margin-left: .34rem; font-size: .32rem; color: #303032; }
  .list-rank-money {margin-right:.3rem;font-size:.28rem;color:#999; }


  /*收入明细*/
  .account-search-info{display:block; width:50%;padding-left:.32rem;}
  .account-search-info .date{display:block;width:100%;line-height:.4rem;margin-top:.12rem;font-size:.28rem;color:#333;}
  .account-search-info .num{display:block;width:100%;line-height:.36rem;font-size:.24rem;color:#999;}
  .account-search{position:relative;height:1rem;line-height:1rem;background:#f9f9f9;}
  .search-con{position:absolute;top:.25rem;right:1.1rem;width:50%;height:.5rem;line-height:.5rem;border:1px solid #ccc;border-radius:.3rem;}
  .search-con input{position:absolute;left:.3rem;right:.7rem;top:0;height:.5rem;line-height:.5rem;font-size:.26rem;color:#666;border-radius:.3rem;background: none;}
  .search-con .icon_search{position:absolute;top:0;right:.08rem;width:.24rem;height:.24rem;padding:.13rem;z-index: 9;}
  .date-picker img{position:absolute;top:.255rem;right:.34rem;width:.5rem;height:.49rem;}

  /*提现记录*/
  .account-list{width:100%;height:auto;background:#fff;}
  .account-list-data{position:relative;width:100%;height:1.5rem;padding:.18rem .24rem .12rem;}
  .account-list-data .data-border{content: '';position:absolute;bottom:0;left:1.3rem;height:1px;right:0;background: #f0f0f0;z-index: 9;}
  .head-img-box{width:1rem;height:100%;}
  .head-img-box img{display:block;width:.8rem;height:.8rem;margin-left:.15rem;border-radius:50%;object-fit: cover;}
  .head-img-box span{display:block;width:100%;line-height:.3rem;margin-top:.05rem;text-align:center;font-size:.22rem;color:#bbc4c8;}
  .account-list-num{width:1.45rem;}
  .account-list-info{margin-left:.24rem;}
  .account-list-info .title{line-height:.30rem;font-size:.28rem;font-weight:bold;color:#666;}
  .account-list-info .type{line-height:.3rem;margin-top:.1rem;font-size:.2rem;color:#6c6c6c;}
  .account-list-info .date{line-height:.3rem;margin-top:.15rem;font-size:.24rem;color:#bbc4c8;}
  .account-list-num .price{font-size:.3rem;color:#fc784a;text-align:right;margin-right:.1rem;line-height:.3rem;}
  .account-list-num .type{margin-top:.1rem;font-size:.24rem;color:#cacbca;}
  .account-list-tx .account-list-data{height:1.5rem;}
  .account-list-tx .account-list-data .data-border{position:absolute;bottom:0;left:20%;height:1px;right:0;background: #f0f0f0;z-index: 9;}
  .account-list-tx .account-list-data .num{font-size:.3rem;text-align:right;padding-right:.1rem;box-sizing:border-box;}
  .icon-dh{display:block;width:.42rem;height:.42rem;margin:0 auto;}

  #select_date{position: absolute;right: .32rem;top: 50%;width: .41rem;height: .41rem;margin-top: -.205rem;background: url(../../assets/icon_calendar.png) no-repeat center;background-size: 100% 100%;}
  #select_date input{background: none;}
</style>



// WEBPACK FOOTER //
// src/page/extend-account/extend-account.vue